import { render, staticRenderFns } from "./Locus.vue?vue&type=template&id=e8220338&scoped=true&lang=pug&"
import script from "./Locus.vue?vue&type=script&lang=js&"
export * from "./Locus.vue?vue&type=script&lang=js&"
import style0 from "./Locus.vue?vue&type=style&index=0&id=e8220338&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8220338",
  null
  
)

export default component.exports